import { message } from 'antd';
import axios from 'axios';
import { DeviceStatus } from '@/constants/enums';
import DeviceInformationService from '@/features/deviceInformation/deviceInformation.service';
import DeviceService from '@/features/devices/Device.service';
import { FetchGroups } from '@/features/groups/actions';
import GroupsService from '@/features/groups/group.service';
import { amazonImageUrl } from '../../utilities/util';
import { GetIcons, GetTimeZones } from '../devices/actions';
import { FETCH_DRIVER_INFO, FETCH_EXTRA_VEHICLE_INFO, FETCH_VEHICLE_INFO } from '../devices/actionTypes';
import { GetDevices } from '../map/actions';
import { FETCH_MAP_DEVICES } from '../map/actionTypes';

export const UpdateVehicleInfo = (newData) => (dispatch, getState) => {
	let state = getState();
	let mapDevices = state.map.devices;
	let vehicleInfoResp = state.device.vehicleInfo;

	let vehicleInfo = {
		numberPlate: newData.numberPlate,
		color: newData.color,
		brand: newData.brand,
		model: newData.model,
		capacity: +newData.capacity,
		VIN: newData.VIN,
		odometer: +newData.odometer,
	};
	let newDevice = {
		description: newData.description,
		iconId: newData.iconId,
		timeZoneId: newData.timeZoneId,
		status: DeviceStatus.ACTIVE,
	};

	let newDeviceInfo = {
		...newDevice,
		utcOffsetMinutes: newData.utcOffsetMinutes,
		icon: +newData.iconId,
	};

	let filteredDevices = mapDevices.map((device) =>
		device.id === newData.deviceId ? { ...device, ...newDeviceInfo } : device
	);
	return DeviceInformationService.update(newData.deviceId, vehicleInfo).then(({ success, error }) => {
		if (error) {
			throw error;
		}
		axios.patch(`/v2/devices/${newData.deviceId}`, newDevice).then(() => {
			window.main.devices[newData.deviceId].updateVehicleInfo(newDeviceInfo);
			dispatch({ type: FETCH_MAP_DEVICES, devices: filteredDevices });
			dispatch({
				type: FETCH_VEHICLE_INFO,
				vehicleInfo: {
					...vehicleInfoResp,
					...success,
					...newDeviceInfo,
				},
			});
		});
	});
};

export const GetDevicesMetaData = (cancelTocken) => async (dispatch) => {
	try {
		const icon = await GetIcons(dispatch, cancelTocken);
		const timeZone = await GetTimeZones(dispatch, cancelTocken);

		return [icon, timeZone];
	} catch (error) {
		Promise.reject(error);
	}
};

export const GetVehicleInfo = (deviceId) => async (dispatch) => {
	const { success, error } = await DeviceInformationService.get(deviceId);

	if (error) {
		throw error;
	}

	let imageUrl = null;

	if (success?.image) {
		imageUrl = amazonImageUrl({ folder: 'vehicle', name: `vehicle_${deviceId}` });
	}

	const vehicleInfo = {
		deviceId: deviceId,
		...success,
		imageUrl,
	};

	dispatch({
		type: FETCH_VEHICLE_INFO,
		vehicleInfo,
	});

	return vehicleInfo;
};

export const updateDriverInfo = (driverInfo) => ({ type: FETCH_DRIVER_INFO, driverInfo });

export const UpdateDriverDevice = (driverInfo) => (dispatch) => {
	if (driverInfo.image) {
		driverInfo.imageUrl = amazonImageUrl({ folder: 'driver', name: `driver_${driverInfo.id}` });
	}
	dispatch({ type: FETCH_DRIVER_INFO, driverInfo });
};

export const GetDriverInfo = (deviceId) => async (dispatch) => {
	try {
		const { success } = await DeviceService.getDriverInfo(deviceId);

		const driverInfo = success;
		if (!driverInfo) {
			dispatch(updateDriverInfo({ deviceId: deviceId }));
			return {
				deviceId: deviceId,
			};
		}

		if (!driverInfo.image) {
			dispatch(updateDriverInfo({ ...driverInfo }));
			return {
				deviceId,
				...driverInfo,
			};
		}

		const imageUrl = amazonImageUrl({ folder: 'driver', name: `driver_${driverInfo.id}` });
		dispatch(updateDriverInfo({ ...driverInfo, imageUrl }));
		return {
			...driverInfo,
			imageUrl,
		};
	} catch (error) {
		return Promise.reject(error);
	}
};

export const AddExtraInfo = (extraVehicleInfo) => (dispatch, getState) => {
	let state = getState();

	let extraInfo = state.device.extraVehicleInfo;
	let messages = state.language.messages;
	return DeviceService.createExtraInfo(extraVehicleInfo).then(({ success, error }) => {
		if (error) {
			message.error({ content: messages['commonError'], key: 'commonError' });
			return Promise.reject(error);
		}
		dispatch({
			type: FETCH_EXTRA_VEHICLE_INFO,
			extraVehicleInfo: [...extraInfo, success],
		});
		return success;
	});
};

export const UpdateExtraInfo = (deviceId, extraVehicleInfo) => (dispatch, getState) => {
	let state = getState();
	let messages = state.language.messages;
	return DeviceService.updateExtraInfo(deviceId, extraVehicleInfo).then(({ success, error }) => {
		if (error) {
			message.error({ content: messages['commonError'], key: 'commonError' });
			return Promise.reject(error);
		}
		dispatch({
			type: FETCH_EXTRA_VEHICLE_INFO,
			extraVehicleInfo: success,
		});
	});
};

export const DeleteExtraInfo = (id, deviceId) => (dispatch, getState) => {
	let state = getState();
	let messages = state.language.messages;
	let extraVehicleInfo = state.device.extraVehicleInfo;
	let filteredItems = extraVehicleInfo.filter((val) => val.id !== id);

	return DeviceService.deleteExtraInfo({ id, deviceId }).then(({ error }) => {
		if (error) {
			message.error({ content: messages['commonError'], key: 'commonError' });
			return Promise.reject(error);
		}
		dispatch({
			type: FETCH_EXTRA_VEHICLE_INFO,
			extraVehicleInfo: filteredItems,
		});
	});
};

export const SetExtraInfo = (extraInfo = []) => {
	return {
		type: FETCH_EXTRA_VEHICLE_INFO,
		extraVehicleInfo: extraInfo,
	};
};

export const UpdateVehicleImage = (vehicleInfoResp) => {
	return {
		type: FETCH_VEHICLE_INFO,
		vehicleInfo: {
			...vehicleInfoResp,
			imageUrl: amazonImageUrl({ folder: 'vehicle', name: `vehicle_${vehicleInfoResp.deviceId}` }),
		},
	};
};

export const initVehiculeInfo = (deviceId, extraInfo) => async (dispatch) => {
	try {
		const [vehicleInfo, driverInfo] = await Promise.all([
			dispatch(GetVehicleInfo(deviceId)),
			dispatch(GetDriverInfo(deviceId)),
		]);
		dispatch(SetExtraInfo(extraInfo));
		return { vehicleInfo, driverInfo, extraInfo };
	} catch (error) {
		return error;
	}
};

export const initDeviceInformationPage = (cancelToken) => async (dispatch) => {
	const {
		success: { data: groups },
	} = await GroupsService.get();
	await dispatch(FetchGroups(groups));
	await GetIcons(dispatch, cancelToken);
	await GetTimeZones(dispatch, cancelToken);

	return dispatch(GetDevices(cancelToken));
};
